import {ContactMessageParams} from './state';
import {filterParams} from '../../common/utils';
import axios from '../../common/axios';
import {Rest} from '../../common/models/rest';
import {BASE_URL} from '../../config/properties';
import {ContactMessage} from '../../models/contact-message';
import {RouterEnum} from '../../common/enums';

const {contact_messages} = RouterEnum;

export class ContactMessageService {

    list(rawParams: ContactMessageParams) {
        const params = rawParams ? filterParams(rawParams) : {};
        return axios.get<Rest<ContactMessage>>(
            `${BASE_URL}${contact_messages}`,
            {params}
        );
    }

    read(id: number) {
        return axios.patch(`${BASE_URL}${contact_messages}/${id}/read`);
    }

    resolve(id: number) {
        return axios.patch(`${BASE_URL}${contact_messages}/${id}/resolve`);
    }

    delete(id: number) {
        return axios.delete(`${BASE_URL}${contact_messages}/${id}`);
    }

}

const contactMessageService = new ContactMessageService();

export default contactMessageService;
